<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12" v-if="successMessage">
				<b-alert variant="success" show class="mb-4 w-100 text-center">{{successMessage}}</b-alert>
			</b-col>
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Detalles del Ticket</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>

					<b-card-body>
						<b-row>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Número de Ticket: </span> {{ticket.ticketNumber}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha de Creación: </span>
									{{ticket.createdAt|dateFormatFull}}</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="ticket.User">
								<h6><span class="text-info">Registrado por: </span> {{ticket.User.firstName}}
									{{ticket.User.lastName}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Tipo Contrato: </span> {{ticket.ContractType}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Estado: </span> {{ticket.stateCodeStr}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Razón para el Estado: </span> {{ticket.statusCodeStr}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Prioridad: </span> {{ticket.priority}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha Propuesta Cliente: </span>
									{{ticket.clientDateProposed|dateFormat}}</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="ticket.AuthDate_1 !== '0001-01-01T00:00:00'">
								<h6><span class="text-info">Fecha Autorización 1: </span>
									{{ticket.AuthDate_1|dateFormatFull}}</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="ticket.AuthDate_2 !== '0001-01-01T00:00:00'">
								<h6><span class="text-info">Fecha Autorización 2: </span>
									{{ticket.AuthDate_2|dateFormatFull}}</h6>
							</b-col>

							<b-col md="4" lg="3" v-if="ticket.AuthDate_3 !== '0001-01-01T00:00:00'">
								<h6><span class="text-info">Fecha Autorización 3: </span>
									{{ticket.AuthDate_3|dateFormatFull}}</h6>
							</b-col>

							<b-col md="12" lg="12" class="mt-3">
								<h6><span class="text-info">Problema-Necesidad: </span> {{ticket.description}}</h6>
							</b-col>
						</b-row>
						<b-row class="justify-content-center mt-3">
							<b-col md="4" lg="4">
								<b-button variant="success"
										  class="btn-block btn-sm"
										  v-if="canAuth && ticket"
										  v-b-modal.confirm-auth-modal>
									<i class="fa fa-check" aria-hidden="true"></i> Autorizar
								</b-button>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>
		<GoBackComponent></GoBackComponent>
		<b-modal
			id="confirm-auth-modal"
			ref="modal"
			title="Autorización"
			centered
			ok-title="Sí"
			cancel-title="No"
			ok-variant="success"
			@ok="handleOK">
			<h5 class="text-center">¿Está seguro de realizar la autorización?</h5>
			<b-row class="justify-content-center" v-if="authLoader">
				<b-col md="12" lg="12" class="text-center">
					Autorizando...
				</b-col>
				<b-col md="1" lg="1" class="text-center">
					<b-spinner variant="info" label="Autorizando..."></b-spinner>
				</b-col>
			</b-row>
		</b-modal>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";

	export default {
		name: "TicketDetail",
		components: {
			AccountDetailComponent,
			GoBackComponent,
		},
		data: function () {
			return {
				accountSelected: '',
				loading: false,
				authLoader: false,
				ticket: '',
				successMessage: ''
			}
		},
		mounted() {
			if (this.$store.state.accountSelected !== '') {
				this.accountSelected = this.$store.state.accountSelected;
				const ticketId = this.$route.params.id;
				this.getTicketDetail(ticketId);

			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			getTicketDetail(ticketId) {
				this.loading = true;

				this.$store.dispatch('getTicketDetail', ticketId)
					.then((ticket) => {
						this.ticket = ticket;
					})
					.finally(() => {
						this.loading = false;
					})
			},
			handleOK(bvModalEvt) {
				bvModalEvt.preventDefault();
				this.authLoader = true;

				this.$store.dispatch('authTicket', this.ticket.ticketID)
					.then((response) => {
						this.successMessage = response;
						this.getTicketDetail(this.ticket.ticketID);
						this.$nextTick(() => {
							this.$bvModal.hide('confirm-auth-modal');
						});
					})
					.finally(() => {
						this.authLoader = false;
					});
			},
		},
		computed: {
			canAuth() {
				if (this.ticket && this.ticket.ContractTypeCode === 100000000 && this.accountSelected.requieredAuth) {
					const user = JSON.parse(this.$store.state.user);

					if (this.ticket.AuthUser_1 === null && this.accountSelected.AuthUser_1.userID === user.userID) {
						return true;
					}

					if (this.accountSelected.AuthType === 100000001 && this.ticket.AuthUser_2 === null && this.accountSelected.AuthUser_2.userID === user.userID) {
						return true;
					}

					if (this.accountSelected.AuthType === 100000002) {
						if (this.ticket.AuthUser_2 === null && this.accountSelected.AuthUser_2.userID === user.userID) {
							return true;
						} else if (this.ticket.AuthUser_3 === null && this.accountSelected.AuthUser_3.userID === user.userID) {
							return true;
						}
					}

					return false;
				} else {
					return false;
				}
			}
		}
	}
</script>

<style scoped>

</style>
